module.exports = __webpack_public_path__ + "public/img/logo1.03da2218.png";